/* eslint jsx-a11y/anchor-has-content: 0 */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import cn from 'classnames';
import { noop, omit } from 'lodash';
import { node, string, shape, bool } from 'prop-types';

import IconButton from 'components/Common/IconButton';
import Tooltip from 'components/Common/Tooltip';

import { withMenuOnClickItem } from 'containers/withMenu';

import s from './SideNavIcon.css';

const defaultStyle = {
  width: 24,
  height: 24,
  margin: 16,
};

@withMenuOnClickItem
export default class SideNavIcon extends React.Component {
  render() {
    const {
      linkTo,
      href,
      className,
      style,
      children,
      isLocked,
      activeClassname,
      isActive,
      isMenuVisible,
      hideTooltip,
      ...restProps
    } = this.props;

    // NOTE: the div directly under Tooltip is to make the hover work properly
    return (
      <IconButton
        className={cn(s.icon, className, {
          [activeClassname]: isActive || isMenuVisible,
          [s.activeIcon]: isActive || isMenuVisible,
        })}
        onClick={noop}
        style={{
          ...defaultStyle,
          ...style,
        }}
        {...omit(restProps, ['isHovered', 'hideMenu'])}
        title=""
      >
        <Tooltip
          placement="right"
          title={isMenuVisible || hideTooltip ? '' : 'Show Options'}
        >
          <div>{children}</div>
        </Tooltip>
      </IconButton>
    );
  }
}

SideNavIcon.propTypes = {
  children: node,
  linkTo: string,
  href: string,
  style: shape({}),
  className: string,
  isLocked: bool,
  activeClassname: string,
  isActive: bool,
  isHovered: bool,
  isMenuVisible: bool,
  hideTooltip: bool,
};

SideNavIcon.defaultProps = {
  className: undefined,
  style: undefined,
  children: undefined,
  linkTo: undefined,
  href: undefined,
  isLocked: false,
  activeClassname: '',
  isActive: false,
  isHovered: false,
  isMenuVisible: false,
  hideTooltip: false,
};
